<template>
  <div class="form-messages">
    <div v-for="formMessage in formMessages" :key="formMessage" v-html="formMessage">
    </div>
  </div>
</template>

<script>
export default {
  props: ['formMessages'],
};
</script>



// WEBPACK FOOTER //
// src/components/presentational/FormMessages.vue?21033060